import { Coordinates } from '../types/locations';
import { PlaceResultType } from '../types/placeResultLocation';

const reverseGeocode = async (coordinates: Coordinates): Promise<PlaceResultType> => {
  const { latitude, longitude } = coordinates;

  const geocoder = new window.google.maps.Geocoder();

  return new Promise<PlaceResultType>((resolve, reject) => {
    geocoder.geocode({ location: { lat: latitude!, lng: longitude! } }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        if (results && results.length > 0 && results[0].geometry !== undefined) {
          const addressComponents = results[0].address_components;
          const city =
            addressComponents?.find((component) => component.types.includes('locality'))
              ?.long_name || '';

          const region =
            addressComponents?.find((component) =>
              component.types.includes('administrative_area_level_1'),
            )?.long_name || '';

          const postalCode =
            addressComponents?.find((component) => component.types.includes('postal_code'))
              ?.long_name || '';

          const parsedPlace: PlaceResultType = {
            formattedAddress: results[0].formatted_address,
            name: results[0].formatted_address,
            placeId: results[0].place_id,
            types: results[0].types,
            city,
            region,
            postalCode,
            geometry: {
              location: {
                lat: results[0].geometry?.location?.lat(),
                lng: results[0].geometry?.location?.lng(),
              },
            },
          };

          resolve(parsedPlace);
        } else {
          reject(new Error('No results found'));
        }
      } else {
        reject(new Error(`Geocoder failed due to: ${status}`));
      }
    });
  });
};

export default reverseGeocode;
